(() => {
  if (window.moriMainProductScriptLoaded) return;

  window.moriMainProductScriptLoaded = true;

  let moriProductZoom = null;

  function initialiseMoriProductZoom() {
    if (typeof window.mediumZoom !== 'function') return;

    const zoomableImages = document.querySelectorAll('.mori-product-section .mori-product-media__image');

    if (zoomableImages.length === 0) return;

    if (!moriProductZoom) {
      moriProductZoom = window.mediumZoom(zoomableImages, {
        margin: 24,
        background: '#363b4861',
      });
    } else {
      moriProductZoom.attach(zoomableImages);
    }
  }

  const moriLinkedProductCache = new Map();
  const moriLinkedProductSupportRoots = [
    '#ProductRoot',
    '#DiscountPromptConfig',
    '#FeaturedReviewsRoot',
  ];
  let moriLinkedProductRequestController = null;
  let moriLinkedProductRequestSequence = 0;

  function getMoriSectionId(sectionWrapper) {
    const wrapperId = sectionWrapper ? sectionWrapper.id : '';
    const prefix = 'shopify-section-';

    return wrapperId.startsWith(prefix) ? wrapperId.slice(prefix.length) : '';
  }

  function getMoriLinkedProductSectionContext() {
    const productSection = document.querySelector('.mori-product-section[data-section]');
    const productSectionWrapper = productSection
      ? productSection.closest('.shopify-section')
      : null;
    const mainSectionId = productSection ? productSection.dataset.section : '';

    if (!productSection || !productSectionWrapper || !mainSectionId) return null;

    const sectionIds = [mainSectionId];

    moriLinkedProductSupportRoots.forEach((selector) => {
      const root = document.querySelector(selector);
      const wrapper = root ? root.closest('.shopify-section') : null;
      const sectionId = getMoriSectionId(wrapper);

      if (sectionId && !sectionIds.includes(sectionId)) sectionIds.push(sectionId);
    });

    return {
      mainSectionId,
      productSection,
      productSectionWrapper,
      sectionIds,
    };
  }

  function getMoriRenderedSection(html, sectionId) {
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');

    return documentFragment.getElementById(`shopify-section-${sectionId}`);
  }

  function reinitialiseMoriReviewsRatingSnippet() {
    if (typeof window.reinitialiseRatingSnippet !== 'function') return;

    window.requestAnimationFrame(() => {
      window.reinitialiseRatingSnippet();
    });
  }

  function unmountMoriLegacyProductRoots(sectionWrapper) {
    if (!window.ReactDOM || typeof window.ReactDOM.unmountComponentAtNode !== 'function') return;

    sectionWrapper.querySelectorAll(
      '#ProductTitleNode, #pricingRoot, #ProductImages, #SizeGuidesNode, #DiscountPromptNode, #ProductAddOns, #FeaturedReviewsNode, #FeaturedVariantProductsNode, #FeaturedProductsNode'
    ).forEach((root) => {
      try {
        window.ReactDOM.unmountComponentAtNode(root);
      } catch (_error) {
        return;
      }
    });
  }

  function replaceMoriLinkedProductSections(sectionResponses, context) {
    const replacements = context.sectionIds.map((sectionId) => {
      const html = sectionResponses[sectionId];
      const currentSection = document.getElementById(`shopify-section-${sectionId}`);
      const newSection = html ? getMoriRenderedSection(html, sectionId) : null;

      if (!currentSection || !newSection) {
        throw new Error(`Unable to render product section: ${sectionId}`);
      }

      return { currentSection, newSection, sectionId };
    });
    const mainReplacement = replacements.find(
      ({ sectionId }) => sectionId === context.mainSectionId
    );

    if (!mainReplacement || !mainReplacement.newSection.querySelector('.mori-product-section')) {
      throw new Error('The linked product does not use the current product template');
    }

    const currentHeading = mainReplacement.currentSection.querySelector('.product__title h1');
    const newHeading = mainReplacement.newSection.querySelector('.product__title h1');
    const currentTitle = currentHeading ? currentHeading.textContent.trim() : '';
    const newTitle = newHeading ? newHeading.textContent.trim() : '';
    const restoreLinkedColourFocus = mainReplacement.currentSection.contains(document.activeElement);

    unmountMoriLegacyProductRoots(mainReplacement.currentSection);
    mainReplacement.currentSection.dispatchEvent(
      new CustomEvent('shopify:section:unload', {
        bubbles: true,
        detail: { moriLinkedProductRender: true },
      })
    );

    replacements
      .filter(({ sectionId }) => sectionId !== context.mainSectionId)
      .forEach(({ currentSection, newSection }) => currentSection.replaceWith(newSection));

    mainReplacement.currentSection.replaceWith(mainReplacement.newSection);
    mainReplacement.newSection.dispatchEvent(
      new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: { moriLinkedProductRender: true },
      })
    );
    document.dispatchEvent(new CustomEvent('reloadSection'));
    reinitialiseMoriReviewsRatingSnippet();

    if (currentTitle && newTitle && document.title.includes(currentTitle)) {
      document.title = document.title.replace(currentTitle, newTitle);
    }

    if (restoreLinkedColourFocus) {
      window.requestAnimationFrame(() => {
        const linkedColourControl = mainReplacement.newSection.querySelector(
          '.mori-variant-picker__select-wrap--colour .mori-custom-select__trigger, [data-linked-colour-link][aria-current="page"]'
        );

        if (linkedColourControl) linkedColourControl.focus({ preventScroll: true });
      });
    }

    if (window.Shopify && window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }
  }

  function fetchMoriLinkedProductSections(navigationUrl, context, signal) {
    const requestUrl = new URL(navigationUrl, window.location.href);
    const cacheKey = `${requestUrl.pathname}${requestUrl.search}|${context.sectionIds.join(',')}`;

    if (moriLinkedProductCache.has(cacheKey)) {
      return Promise.resolve(moriLinkedProductCache.get(cacheKey));
    }

    requestUrl.hash = '';
    requestUrl.searchParams.set('sections', context.sectionIds.join(','));

    return fetch(requestUrl.toString(), {
      credentials: 'same-origin',
      signal,
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Product section request failed: ${response.status}`);

        return response.json();
      })
      .then((sectionResponses) => {
        context.sectionIds.forEach((sectionId) => {
          if (!sectionResponses[sectionId]) {
            throw new Error(`Product section response is missing: ${sectionId}`);
          }
        });

        moriLinkedProductCache.set(cacheKey, sectionResponses);

        return sectionResponses;
      });
  }

  function renderMoriLinkedProduct(url, historyMode = 'push') {
    const navigationUrl = new URL(url, window.location.href);
    const currentUrl = new URL(window.location.href);
    const context = getMoriLinkedProductSectionContext();
    const testMarket = currentUrl.searchParams.get('mori_test_market');

    if (testMarket && !navigationUrl.searchParams.has('mori_test_market')) {
      navigationUrl.searchParams.set('mori_test_market', testMarket);
    }

    if (currentUrl.searchParams.get("view") === "redesign") {
      console.log("Adding the redesign param")
      navigationUrl.searchParams.set("view", "redesign");
    }

    if (!context || navigationUrl.origin !== window.location.origin) {

      window.location.assign(navigationUrl.toString());

      return Promise.resolve();
    }

    if (moriLinkedProductRequestController) moriLinkedProductRequestController.abort();

    const requestController = new AbortController();
    const requestSequence = ++moriLinkedProductRequestSequence;

    moriLinkedProductRequestController = requestController;
    context.productSection.setAttribute('aria-busy', 'true');

    return fetchMoriLinkedProductSections(
      navigationUrl.toString(),
      context,
      requestController.signal
    )
      .then((sectionResponses) => {
        if (requestSequence !== moriLinkedProductRequestSequence) return;

        replaceMoriLinkedProductSections(sectionResponses, context);

        const browserUrl = `${navigationUrl.pathname}${navigationUrl.search}${navigationUrl.hash}`;
        const currentHistoryState = window.history.state && typeof window.history.state === 'object'
          ? window.history.state
          : {};
        const historyState = Object.assign({}, currentHistoryState, {
          moriLinkedProductUrl: browserUrl,
        });

        if (historyMode === 'replace') {
          window.history.replaceState(historyState, '', browserUrl);
        } else if (historyMode === 'push') {
          window.history.pushState(historyState, '', browserUrl);
        }
      })
      .catch((error) => {
        if (error.name === 'AbortError' || requestSequence !== moriLinkedProductRequestSequence) return;

        if (historyMode === 'popstate') {
          window.location.reload();
        } else {
          window.location.assign(navigationUrl.toString());
        }
      })
      .then(() => {
        if (requestSequence !== moriLinkedProductRequestSequence) return;

        moriLinkedProductRequestController = null;

        const busyProductSection = document.querySelector(
          '.mori-product-section[aria-busy="true"]'
        );

        if (busyProductSection) busyProductSection.removeAttribute('aria-busy');
      });
  }

  const moriMediaFilterDimensions = ['colour', 'size', 'tog'];

  function normaliseMoriMediaFilterValue(value, dimension = '') {
    const normalisedValue = String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '');

    return dimension === 'tog'
      ? normalisedValue.replace(/tog$/, '')
      : normalisedValue;
  }

  function getMoriMediaOptionConfig(grid, dimension) {
    return {
      position: Number(grid.dataset[`${dimension}OptionPosition`] || 0),
      name: normaliseMoriOptionName(grid.dataset[`${dimension}OptionName`]),
      valueCount: Number(grid.dataset[`${dimension}OptionValueCount`] || 0),
    };
  }

  function getMoriSelectedMediaOption(grid, assignment, dimension) {
    const optionConfig = getMoriMediaOptionConfig(grid, dimension);

    if (!optionConfig.position) return '';

    const section = grid.closest('.mori-product-section');
    const picker = section
      ? section.querySelector(
        '.mori-variant-picker:not(.mori-variant-picker__compatibility), .mori-variant-picker--legacy'
      )
      : null;
    const optionSelect = picker
      ? picker.querySelector(`select[data-option-position="${optionConfig.position}"]`)
      : null;

    if (optionSelect && optionSelect.value) return optionSelect.value;

    const selectedRadio = picker
      ? Array.from(picker.querySelectorAll('input[type="radio"]:checked')).find(
        (input) => normaliseMoriOptionName(input.name) === optionConfig.name
      )
      : null;

    if (selectedRadio) return selectedRadio.value;

    if (
      assignment
      && Array.isArray(assignment.options)
      && (optionConfig.valueCount === 1 || dimension === 'colour')
    ) {
      return assignment.options[optionConfig.position - 1] || '';
    }

    return '';
  }

  function getMoriMediaFilters(item) {
    const filters = {
      colour: [],
      size: [],
      tog: [],
    };

    if (!window.location.href.toLowerCase().includes('-set')) return filters;

    const filterClause = String(item.dataset.mediaAlt || '').split('|')[0];
    const filterPattern = /(?:^|\s)filter_(colour|color|size|tog)=([^\s|]+)/gi;
    let match = filterPattern.exec(filterClause);

    while (match) {
      const dimension = match[1].toLowerCase() === 'color' ? 'colour' : match[1].toLowerCase();
      const values = match[2]
        .split(',')
        .map((value) => normaliseMoriMediaFilterValue(value, dimension))
        .filter(Boolean);

      filters[dimension] = [...new Set([...filters[dimension], ...values])];
      match = filterPattern.exec(filterClause);
    }

    const legacyTogPattern = /(?:^|\s)filter_image_([a-z0-9_]+)_tog(?:\s|$)/gi;
    let legacyTogMatch = legacyTogPattern.exec(filterClause);

    while (legacyTogMatch) {
      const legacyTog = normaliseMoriMediaFilterValue(legacyTogMatch[1], 'tog');

      if (legacyTog) filters.tog = [...new Set([...filters.tog, legacyTog])];
      legacyTogMatch = legacyTogPattern.exec(filterClause);
    }

    return filters;
  }

  function getMoriSelectedMediaFilters(grid, assignment) {
    return moriMediaFilterDimensions.reduce((selectedFilters, dimension) => {
      selectedFilters[dimension] = normaliseMoriMediaFilterValue(
        getMoriSelectedMediaOption(grid, assignment, dimension),
        dimension
      );

      return selectedFilters;
    }, {});
  }

  function moriMediaMatchesSelections(mediaFilters, selectedFilters) {
    return moriMediaFilterDimensions.every((dimension) => {
      const selectedValue = selectedFilters[dimension];
      const filterValues = mediaFilters[dimension];

      if (!selectedValue || !filterValues.length) return true;

      return filterValues.includes(selectedValue);
    });
  }

  function syncMoriMediaAccessibility(item) {
    const accessibleAlt = String(item.dataset.mediaAccessibleAlt || '').trim();

    if (!accessibleAlt) return;

    item.querySelectorAll('img').forEach((image) => {
      image.alt = accessibleAlt;
    });
    item.querySelectorAll('video, model-viewer').forEach((media) => {
      media.setAttribute('aria-label', accessibleAlt);
    });
    item.querySelectorAll('iframe').forEach((frame) => {
      frame.title = accessibleAlt;
    });
  }

  function syncMoriProductMediaPlayback(grid) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    grid.querySelectorAll('video').forEach((video) => {
      const item = video.closest('[data-media-id]');
      const isVisible = item && !item.hidden;
      const isAutoplayVideo = item && item.dataset.videoMode === 'autoplay';
      const isInViewport = video.dataset.moriInViewport === 'true';
      const isManuallyPaused = video.dataset.moriManuallyPaused === 'true';

      if (!isVisible) {
        video.pause();
      }

      if (!isAutoplayVideo) return;

      video.controls = false;

      if (reducedMotion || !isInViewport) {
        video.pause();

        return;
      }

      if (isVisible && !isManuallyPaused) {
        const playRequest = video.play();

        if (playRequest && typeof playRequest.catch === 'function') {
          playRequest.catch(() => {});
        }
      }
    });
  }

  function initialiseMoriProductMediaPlayback(grid) {
    const autoplayVideos = Array.from(
      grid.querySelectorAll('[data-video-mode="autoplay"] video')
    );

    if (!autoplayVideos.length || grid.moriMediaPlaybackCleanup) return;

    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.dataset.moriInViewport = String(entry.isIntersecting);
      });
      syncMoriProductMediaPlayback(grid);
    }, { threshold: 0.15 });
    const handleReducedMotionChange = () => syncMoriProductMediaPlayback(grid);

    autoplayVideos.forEach((video) => {
      const item = video.closest('[data-media-id]');
      const toggle = item ? item.querySelector('[data-mori-video-toggle]') : null;
      const updateToggle = () => {
        if (!item || !toggle) return;

        const hasEnded = video.ended;
        item.dataset.videoPlaybackState = hasEnded ? 'ended' : video.paused ? 'paused' : 'playing';
        toggle.setAttribute('aria-label', hasEnded ? 'Replay video' : video.paused ? 'Play video' : 'Pause video');
      };
      const handleEnded = updateToggle;
      const handleToggle = () => {
        if (video.ended) {
          video.currentTime = 0;
          delete video.dataset.moriManuallyPaused;
        }

        if (video.paused) {
          delete video.dataset.moriManuallyPaused;
          const playRequest = video.play();

          if (playRequest && typeof playRequest.catch === 'function') {
            playRequest.catch(() => {});
          }
        } else {
          video.dataset.moriManuallyPaused = 'true';
          video.pause();
        }
      };

      video.dataset.moriInViewport = 'false';
      video.addEventListener('ended', handleEnded);
      video.addEventListener('play', updateToggle);
      video.addEventListener('pause', updateToggle);
      if (toggle) toggle.addEventListener('click', handleToggle);
      video.moriPlaybackHandlers = { handleEnded, handleToggle, updateToggle, toggle };
      intersectionObserver.observe(video);
      updateToggle();
    });
    reducedMotionQuery.addEventListener('change', handleReducedMotionChange);

    grid.moriMediaPlaybackCleanup = () => {
      intersectionObserver.disconnect();
      reducedMotionQuery.removeEventListener('change', handleReducedMotionChange);
      grid.querySelectorAll('video').forEach((video) => {
        video.pause();
        if (video.moriPlaybackHandlers) {
          const { handleEnded, handleToggle, updateToggle, toggle } = video.moriPlaybackHandlers;
          video.removeEventListener('ended', handleEnded);
          video.removeEventListener('play', updateToggle);
          video.removeEventListener('pause', updateToggle);
          if (toggle) toggle.removeEventListener('click', handleToggle);
          delete video.moriPlaybackHandlers;
        }
      });
      delete grid.moriMediaPlaybackCleanup;
    };

    syncMoriProductMediaPlayback(grid);
  }

  function updateMoriProductMediaGrid(grid, variantId, resetPosition = false) {
    const allItems = Array.from(grid.querySelectorAll('[data-media-id]')).sort(
      (first, second) => Number(first.dataset.mediaPosition) - Number(second.dataset.mediaPosition)
    );

    if (!allItems.length) return;

    const assignment = grid.moriVariantMediaMap
      ? grid.moriVariantMediaMap[String(variantId)]
      : null;
    const legacyFilters = assignment && Array.isArray(assignment.options)
      ? assignment.options.map((option) => {
        const handle = String(option || '')
          .toLowerCase()
          .replace(' m', 'm')
          .replace(/[^\w\u00c0-\u024f]+/g, '-')
          .replace(/^-+|-+$/g, '')
          .replace(/-/g, '_');

        return `filter_image_${handle}`;
      })
      : [];
    const eligibleItems = allItems.filter(
      (item) => !String(item.dataset.mediaAlt || '')
        .toLowerCase()
        .includes('personalisation')
    );
    const legacyFilteredItems = eligibleItems.filter((item) => {
      const mediaAlt = String(item.dataset.mediaAlt || '').toLowerCase();
      const mediaFilters = getMoriMediaFilters(item);
      const hasStructuredFilters = moriMediaFilterDimensions.some(
        (dimension) => mediaFilters[dimension].length
      );

      if (hasStructuredFilters) return true;

      if (!mediaAlt.includes('filter_image_')) return true;

      const legacyMediaFilters = mediaAlt.split(' ').map((part) => part.trim());

      return legacyFilters.some((filter) => legacyMediaFilters.includes(filter));
    });
    const selectedFilters = getMoriSelectedMediaFilters(grid, assignment);
    const sizeOptionConfig = getMoriMediaOptionConfig(grid, 'size');
    const structuredFilteredItems = legacyFilteredItems.filter((item) =>
      moriMediaMatchesSelections(getMoriMediaFilters(item), selectedFilters)
    );
    const genericItems = legacyFilteredItems.filter((item) => {
      const mediaFilters = getMoriMediaFilters(item);

      return !moriMediaFilterDimensions.some(
        (dimension) => mediaFilters[dimension].length
      );
    });
    let filteredItems = structuredFilteredItems.length
      ? structuredFilteredItems
      : genericItems;

    if (sizeOptionConfig.position && !selectedFilters.size && window.location.href.toLowerCase().includes('-set')) {
      filteredItems = (filteredItems.length ? filteredItems : legacyFilteredItems).slice(0, 3);
    }

    const items = filteredItems.length
      ? filteredItems
      : eligibleItems.length
        ? eligibleItems
        : allItems;
    const orderedItems = items;
    const visibleCount = orderedItems.length;

    grid.dataset.selectedVariantId = variantId ? String(variantId) : '';
    grid.dataset.visibleMediaCount = String(visibleCount);

    allItems.forEach((item) => {
      syncMoriMediaAccessibility(item);
      item.hidden = true;
      item.classList.remove('mori-product-media__item--featured', 'mori-product-media__item--wide');
    });

    orderedItems.forEach((item, index) => {
      item.style.order = String(index);
      item.hidden = index >= visibleCount;
      item.classList.toggle('mori-product-media__item--featured', index === 0);
      item.classList.toggle(
        'mori-product-media__item--wide',
        visibleCount === 1
      );
    });

    syncMoriProductMediaPlayback(grid);

    if (resetPosition && window.matchMedia('(max-width: 749px)').matches) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.requestAnimationFrame(() => {
        grid.scrollTo({ left: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
      });
    }
  }

  function initialiseMoriProductMediaGrids() {
    document.querySelectorAll('[data-product-media-grid]').forEach((grid) => {
      if (grid.dataset.initialised === 'true') return;

      const mapScript = grid.querySelector('[data-variant-media-map]');

      try {
        grid.moriVariantMediaMap = mapScript ? JSON.parse(mapScript.textContent) : {};
      } catch (error) {
        grid.moriVariantMediaMap = {};
      }

      grid.dataset.initialised = 'true';
      initialiseMoriProductMediaPlayback(grid);
      updateMoriProductMediaGrid(grid, grid.dataset.selectedVariantId);
    });
  }

  function syncMoriProductMediaToVariant(event) {
    const variant = event.detail && event.detail.variant ? event.detail.variant : null;
    const variantId = variant ? variant.id : null;

    if (!variantId) return;

    document.querySelectorAll('[data-product-media-grid]').forEach((grid) => {
      const hasMappedVariant =
        grid.moriVariantMediaMap &&
        Object.prototype.hasOwnProperty.call(grid.moriVariantMediaMap, String(variantId));
      if (hasMappedVariant) {
        updateMoriProductMediaGrid(grid, variantId, true);
      }
    });
  }

  function initialiseMoriLinkedColourSelects() {
    document.querySelectorAll('[data-linked-colour-select]').forEach((select) => {
      if (select.dataset.initialised === 'true') return;

      select.dataset.initialised = 'true';
      select.addEventListener('change', () => {
        if (select.value) renderMoriLinkedProduct(select.value);
      });
    });
  }

  function applyMoriLegacySwatch(target, swatchHandle, productHandle = '') {
    if (!target || !swatchHandle) return;

    const probe = document.createElement('span');
    const probeVisual = document.createElement('label');

    probe.className = `swatch-element color colour-swatch available ${productHandle} ${swatchHandle}`.trim();
    probeVisual.className = `collection_swatch ${swatchHandle}`;
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:fixed;left:-9999px;top:-9999px;';
    probe.appendChild(probeVisual);
    document.body.appendChild(probe);

    const legacyStyle = window.getComputedStyle(probeVisual);
    target.style.backgroundImage =
      legacyStyle.backgroundImage !== 'none' ? legacyStyle.backgroundImage : '';
    target.style.backgroundColor =
      legacyStyle.backgroundColor !== 'rgba(0, 0, 0, 0)'
        ? legacyStyle.backgroundColor
        : 'var(--brand-kidly)';
    target.style.backgroundPosition = legacyStyle.backgroundPosition;
    target.style.backgroundRepeat = legacyStyle.backgroundRepeat;
    target.style.backgroundSize = legacyStyle.backgroundSize;
    probe.remove();
  }

  function applyMoriDropdownSwatch(select) {
    const swatch = select.parentElement
      ? select.parentElement.querySelector('[data-selected-colour-swatch]')
      : null;
    const selectedOption = select.selectedOptions[0];

    if (!swatch || !selectedOption) return;

    applyMoriOptionSwatch(swatch, selectedOption);
  }

  function applyMoriOptionSwatch(swatch, option) {
    if (!swatch || !option) return;

    const swatchImage = option.dataset.swatchImage || '';
    const swatchColor = option.dataset.swatchColor || '';
    const swatchHandle = option.dataset.swatchHandle || '';
    const productHandle = option.dataset.swatchProductHandle || '';

    swatch.style.backgroundImage = swatchImage ? `url("${swatchImage}")` : '';
    swatch.style.backgroundColor = swatchColor || 'var(--brand-kidly)';
    swatch.style.backgroundPosition = '';
    swatch.style.backgroundRepeat = '';
    swatch.style.backgroundSize = '';

    if (!swatchImage && !swatchColor) applyMoriLegacySwatch(swatch, swatchHandle, productHandle);
  }

  function initialiseMoriDropdownSwatches() {
    document.querySelectorAll('[data-colour-option-select]').forEach((select) => {
      if (select.dataset.swatchInitialised === 'true') return;

      select.dataset.swatchInitialised = 'true';
      select.addEventListener('change', () => applyMoriDropdownSwatch(select));
      applyMoriDropdownSwatch(select);
    });
  }

  function syncMoriCustomSelect(select) {
    if (select && typeof select.moriCustomSelectSync === 'function') {
      select.moriCustomSelectSync();
    }
  }

  function parseMoriJsonScript(script) {
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('Unable to parse MORI product option data.', error);

      return null;
    }
  }

  function normaliseMoriOptionName(name) {
    return String(name || '').trim()
      .toLocaleLowerCase();
  }

  function getMoriSelectOptionName(select) {
    const match = String(select.name || '').match(/^options\[(.+)]$/);

    return normaliseMoriOptionName(match ? match[1] : '');
  }

  function getMoriVariantOption(variant, position) {
    if (Array.isArray(variant.options)) return variant.options[position - 1];

    return variant[`option${position}`];
  }

  function getMoriMoneyFormat() {
    const config = parseMoriJsonScript(document.getElementById('shopConfig'));

    return config && config.moneyFormat ? config.moneyFormat : '${{amount}}';
  }

  function formatMoriOptionMoney(amount) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amount, getMoriMoneyFormat());
    }

    const config = parseMoriJsonScript(document.getElementById('shopConfig')) || {};

    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: config.currency || 'GBP',
    }).format(Number(amount || 0) / 100);
  }

  function getMoriColourOptionState(productData, colourValue, selectedOptions) {
    if (!productData || !Array.isArray(productData.options) || !Array.isArray(productData.variants)) return null;

    const colourPosition = productData.options.findIndex((name) => {
      const normalisedName = normaliseMoriOptionName(name);

      return normalisedName.includes('color') || normalisedName.includes('colour');
    }) + 1;

    if (!colourPosition) return null;

    const matchingColourVariants = productData.variants.filter(
      (variant) => getMoriVariantOption(variant, colourPosition) === colourValue
    );
    let hasEveryNonColourSelection = true;
    const matchingSelectionVariants = matchingColourVariants.filter((variant) =>
      productData.options.every((name, index) => {
        if (index + 1 === colourPosition) return true;

        const selectedValue = selectedOptions.get(normaliseMoriOptionName(name));
        if (!selectedValue) {
          hasEveryNonColourSelection = false;

          return true;
        }

        return getMoriVariantOption(variant, index + 1) === selectedValue;
      })
    );
    const constrainedVariants = hasEveryNonColourSelection
      ? matchingSelectionVariants
      : matchingColourVariants;
    const priceCandidates = constrainedVariants.length ? constrainedVariants : matchingColourVariants;
    const availableCandidates = constrainedVariants.filter((variant) => variant.available);
    const representativeVariants = availableCandidates.length ? availableCandidates : priceCandidates;
    const representativeVariant = representativeVariants.reduce((lowest, variant) => {
      if (!lowest || Number(variant.price) < Number(lowest.price)) return variant;

      return lowest;
    }, null);

    if (!representativeVariant) return null;

    const price = Number(representativeVariant.price || 0);
    const compareAtPrice = Number(representativeVariant.compare_at_price || 0);
    const hasVariablePrice = new Set(
      representativeVariants.map((variant) => Number(variant.price || 0))
    ).size > 1;

    return {
      available: availableCandidates.length > 0,
      compareAtPrice,
      fromPrice: hasVariablePrice,
      onSale: compareAtPrice > price,
      price,
      variantId: constrainedVariants.length ? representativeVariant.id : null,
    };
  }

  function isMoriOptionValueAvailable(productData, optionPosition, optionValue, selectedOptions) {
    if (!productData || !Array.isArray(productData.options) || !Array.isArray(productData.variants)) return false;

    return productData.variants.some((variant) => {
      if (!variant.available || getMoriVariantOption(variant, optionPosition) !== optionValue) return false;

      return productData.options.every((name, index) => {
        const position = index + 1;

        if (position === optionPosition) return true;

        const selectedValue = selectedOptions.get(normaliseMoriOptionName(name));

        return !selectedValue || getMoriVariantOption(variant, position) === selectedValue;
      });
    });
  }

  function initialiseMoriDropdownOptionStates() {
    document.querySelectorAll('.mori-product-section').forEach((section) => {
      if (section.dataset.dropdownOptionStatesInitialised === 'true') return;

      const visiblePicker = section.querySelector('.mori-variant-picker--dropdown');
      const optionSelects = section.querySelectorAll('select[data-option-position]');

      if (!visiblePicker || !optionSelects.length) return;

      const colourSelects = section.querySelectorAll('select[data-colour-option-select]');
      const currentProductData = parseMoriJsonScript(visiblePicker.querySelector('[data-product-variant-data]'));
      const linkedDataScript = section.querySelector('[data-linked-colour-variant-data]');
      const linkedProducts = parseMoriJsonScript(linkedDataScript) || [];
      const linkedProductsByHandle = new Map(linkedProducts.map((productData) => [productData.handle, productData]));
      const fromTemplate = visiblePicker.dataset.priceFromTemplate || '[price]';
      const unavailableLabel = visiblePicker.dataset.unavailableLabel || 'Unavailable';

      const updateOptionStates = () => {
        const selectedOptions = new Map();

        visiblePicker.querySelectorAll('select[data-option-position]').forEach((select) => {
          const optionName = getMoriSelectOptionName(select);
          const selectedOption = select.selectedOptions[0];
          const selectedValue = selectedOption
            ? selectedOption.dataset.linkedColourValue || selectedOption.value
            : '';

          if (optionName && selectedValue) selectedOptions.set(optionName, selectedValue);
        });

        colourSelects.forEach((select) => {
          Array.from(select.options).forEach((option) => {
            const productData = option.dataset.linkedProductHandle
              ? linkedProductsByHandle.get(option.dataset.linkedProductHandle)
              : currentProductData;
            const colourValue = option.dataset.linkedColourValue || option.value;
            const state = getMoriColourOptionState(productData, colourValue, selectedOptions);

            if (!state) return;

            const optionLabel = option.dataset.optionLabel || option.value;
            const formattedPrice = formatMoriOptionMoney(state.price);
            const formattedCompareAtPrice = state.onSale
              ? formatMoriOptionMoney(state.compareAtPrice)
              : '';

            option.dataset.optionPrice = state.fromPrice
              ? fromTemplate.replace('[price]', formattedPrice)
              : formattedPrice;
            option.dataset.optionCompareAtPrice = formattedCompareAtPrice;
            option.dataset.optionOnSale = String(state.onSale);
            option.dataset.optionUnavailable = String(!state.available);
            option.dataset.optionUnavailableLabel = unavailableLabel;
            option.classList.toggle('disabled', !state.available);
            option.textContent = state.available ? optionLabel : `${optionLabel} - ${unavailableLabel}`;

            if (option.dataset.linkedProductUrl) {
              option.value = state.variantId
                ? `${option.dataset.linkedProductUrl}?variant=${state.variantId}`
                : option.dataset.linkedProductUrl;
            }
          });

          syncMoriCustomSelect(select);
        });

        visiblePicker.querySelectorAll('select[data-option-position]:not([data-colour-option-select])').forEach((select) => {
          const optionPosition = Number(select.dataset.optionPosition);

          Array.from(select.options).forEach((option) => {
            if (option.hasAttribute('data-option-placeholder')) return;

            const optionLabel = option.dataset.optionLabel || option.value;
            const unavailable = !isMoriOptionValueAvailable(
              currentProductData,
              optionPosition,
              option.value,
              selectedOptions
            );

            option.dataset.optionUnavailable = String(unavailable);
            option.dataset.optionUnavailableLabel = unavailableLabel;
            option.classList.toggle('disabled', unavailable);
            option.textContent = unavailable ? `${optionLabel} - ${unavailableLabel}` : optionLabel;
          });

          syncMoriCustomSelect(select);
        });
      };

      section.dataset.dropdownOptionStatesInitialised = 'true';
      section.addEventListener('change', (event) => {
        if (event.target instanceof HTMLSelectElement) updateOptionStates();
      });
      updateOptionStates();
    });
  }

  function initialiseMoriCustomSelects() {
    document.querySelectorAll('.mori-variant-picker__select-wrap > .mori-variant-picker__select').forEach((select) => {
      if (select.dataset.customSelectInitialised === 'true') return;

      const wrapper = select.parentElement;
      const group = select.closest('.mori-variant-picker__group');
      const label = group ? group.querySelector('.mori-variant-picker__label') : null;
      const isColour = select.hasAttribute('data-colour-option-select');
      const isSize = getMoriSelectOptionName(select).includes('size');

      if (!wrapper) return;

      window.moriCustomSelectSequence = (window.moriCustomSelectSequence || 0) + 1;
      const controlId = `MoriCustomSelect-${window.moriCustomSelectSequence}`;
      const listboxId = `${controlId}-listbox`;
      const valueId = `${controlId}-value`;
      const trigger = document.createElement('button');
      const triggerSwatch = document.createElement('span');
      const triggerValue = document.createElement('span');
      const chevron = document.createElement('span');
      const menu = document.createElement('div');
      let optionButtons = [];
      let typeahead = '';
      let typeaheadTimer = null;

      trigger.type = 'button';
      trigger.id = controlId;
      trigger.className = 'mori-custom-select__trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', listboxId);

      triggerSwatch.className = 'mori-custom-select__swatch';
      triggerSwatch.hidden = !isColour;
      triggerSwatch.setAttribute('aria-hidden', 'true');

      triggerValue.id = valueId;
      triggerValue.className = 'mori-custom-select__value';

      chevron.className = 'mori-custom-select__chevron';
      chevron.setAttribute('aria-hidden', 'true');

      trigger.append(triggerSwatch, triggerValue, chevron);

      menu.id = listboxId;
      menu.className = 'mori-custom-select__menu';
      menu.setAttribute('role', 'listbox');
      menu.hidden = true;

      if (label) {
        if (!label.id) label.id = `${controlId}-label`;
        label.htmlFor = controlId;
        trigger.setAttribute('aria-labelledby', `${label.id} ${valueId}`);
        menu.setAttribute('aria-labelledby', label.id);
      } else {
        trigger.setAttribute('aria-labelledby', valueId);
      }

      const closeMenu = (restoreFocus = false) => {
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        wrapper.classList.remove('is-open');
        if (restoreFocus) trigger.focus();
      };

      const focusOption = (index) => {
        if (!optionButtons.length) return;
        const boundedIndex = (index + optionButtons.length) % optionButtons.length;
        optionButtons[boundedIndex].focus();
      };

      const openMenu = (focusSelected = true) => {
        document.querySelectorAll('.mori-variant-picker__select-wrap.is-custom-select.is-open').forEach((openWrapper) => {
          if (openWrapper !== wrapper && typeof openWrapper.moriCustomSelectClose === 'function') {
            openWrapper.moriCustomSelectClose();
          }
        });

        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        wrapper.classList.add('is-open');

        if (focusSelected) {
          const selectedOptionIndex = Math.max(select.selectedIndex, 0);
          const selectedButtonIndex = optionButtons.findIndex(
            (option) => Number(option.dataset.optionIndex) === selectedOptionIndex
          );
          window.requestAnimationFrame(() => focusOption(Math.max(selectedButtonIndex, 0)));
        }
      };

      const chooseOption = (index) => {
        const nativeOption = select.options[index];

        if (!nativeOption) return;

        if (select.value !== nativeOption.value) {
          select.value = nativeOption.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          syncMoriCustomSelect(select);
        }

        closeMenu(true);
      };

      const handleOptionKeydown = (event) => {
        const currentIndex = optionButtons.indexOf(event.currentTarget);

        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            focusOption(currentIndex + 1);
            break;
          case 'ArrowUp':
            event.preventDefault();
            focusOption(currentIndex - 1);
            break;
          case 'Home':
            event.preventDefault();
            focusOption(0);
            break;
          case 'End':
            event.preventDefault();
            focusOption(optionButtons.length - 1);
            break;
          case 'Enter':
          case ' ':
            event.preventDefault();
            chooseOption(Number(event.currentTarget.dataset.optionIndex));
            break;
          case 'Escape':
            event.preventDefault();
            closeMenu(true);
            break;
          case 'Tab':
            closeMenu(true);
            break;
          default:
            if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
              typeahead += event.key.toLocaleLowerCase();
              window.clearTimeout(typeaheadTimer);
              typeaheadTimer = window.setTimeout(() => {
                typeahead = '';
              }, 500);

              const matchingIndex = optionButtons.findIndex((button) =>
                button.textContent.trim()
                  .toLocaleLowerCase()
                  .startsWith(typeahead)
              );

              if (matchingIndex >= 0) focusOption(matchingIndex);
            }
        }
      };

      const getOrderedOptionIndexes = () => Array.from(select.options)
        .map((nativeOption, index) => ({ index, nativeOption }))
        .filter(({ nativeOption }) => !nativeOption.hasAttribute('data-option-placeholder'))
        .sort((first, second) => {
          // preserve natural size order for unavailable options
          if (isSize) return first.index - second.index;

          const firstUnavailable = first.nativeOption.classList.contains('disabled');
          const secondUnavailable = second.nativeOption.classList.contains('disabled');

          return Number(firstUnavailable) - Number(secondUnavailable);
        })
        .map(({ index }) => index);

      const buildOptions = (orderedIndexes = getOrderedOptionIndexes()) => {
        menu.replaceChildren();
        optionButtons = orderedIndexes.map((nativeIndex) => {
          const option = document.createElement('button');
          const optionSwatch = document.createElement('span');
          const optionCopy = document.createElement('span');
          const optionLabel = document.createElement('span');
          const optionPricing = document.createElement('span');
          const optionPrice = document.createElement('span');

          option.type = 'button';
          option.id = `${listboxId}-option-${nativeIndex}`;
          option.className = `mori-custom-select__option${isColour ? ' mori-custom-select__option--colour' : ''}`;
          option.setAttribute('role', 'option');
          option.tabIndex = -1;
          option.dataset.optionIndex = String(nativeIndex);

          optionSwatch.className = 'mori-custom-select__swatch';
          optionSwatch.hidden = !isColour;
          optionSwatch.setAttribute('aria-hidden', 'true');

          optionCopy.className = 'mori-custom-select__option-copy';
          optionLabel.className = 'mori-custom-select__option-label';
          optionPricing.className = 'mori-custom-select__option-pricing';
          optionPrice.className = 'mori-custom-select__option-price';
          optionPricing.append(optionPrice);
          optionCopy.append(optionLabel, optionPricing);
          option.append(optionSwatch, optionCopy);
          option.addEventListener('click', () => chooseOption(nativeIndex));
          option.addEventListener('keydown', handleOptionKeydown);
          menu.appendChild(option);

          return option;
        });
      };

      const sync = () => {
        const orderedIndexes = getOrderedOptionIndexes();
        const currentOrder = optionButtons.map((option) => Number(option.dataset.optionIndex));

        if (
          orderedIndexes.length !== currentOrder.length ||
          orderedIndexes.some((index, position) => currentOrder[position] !== index)
        ) {
          buildOptions(orderedIndexes);
        }

        optionButtons.forEach((option) => {
          const nativeOption = select.options[Number(option.dataset.optionIndex)];
          const optionLabel = option.querySelector('.mori-custom-select__option-label');
          const optionPricing = option.querySelector('.mori-custom-select__option-pricing');
          const optionPrice = option.querySelector('.mori-custom-select__option-price');
          const optionSwatch = option.querySelector('.mori-custom-select__swatch');
          const isSelected = nativeOption.selected;
          const isUnavailable = nativeOption.classList.contains('disabled');
          const baseOptionText = nativeOption.dataset.optionLabel || nativeOption.textContent.trim();
          const unavailableText = isUnavailable
            ? nativeOption.dataset.optionUnavailableLabel || ''
            : '';
          const optionText = unavailableText
            ? `${baseOptionText} - ${unavailableText}`
            : baseOptionText;
          const priceText = nativeOption.dataset.optionPrice || '';
          const onSale = nativeOption.dataset.optionOnSale === 'true';

          optionLabel.textContent = optionText;
          optionPrice.textContent = priceText;
          optionPricing.hidden = !priceText;
          option.classList.toggle('is-selected', isSelected);
          option.classList.toggle('is-unavailable', isUnavailable);
          option.classList.toggle('is-on-sale', onSale);
          option.setAttribute('aria-selected', String(isSelected));
          option.setAttribute(
            'aria-label',
            [
              baseOptionText,
              priceText,
              unavailableText,
            ].filter(Boolean).join(', ')
          );

          if (isColour) applyMoriOptionSwatch(optionSwatch, nativeOption);
        });

        const selectedOption = select.selectedOptions[0];

        if (selectedOption) {
          triggerValue.textContent = selectedOption.dataset.optionLabel || selectedOption.textContent.trim();
          if (isColour) applyMoriOptionSwatch(triggerSwatch, selectedOption);
        }
      };

      trigger.addEventListener('click', () => {
        if (menu.hidden) {
          openMenu();
        } else {
          closeMenu();
        }
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          openMenu();
        } else if (event.key === 'Escape' && !menu.hidden) {
          event.preventDefault();
          closeMenu();
        }
      });

      select.addEventListener('change', sync);
      select.dataset.customSelectInitialised = 'true';
      select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');
      select.moriCustomSelectSync = sync;
      wrapper.moriCustomSelectClose = closeMenu;
      wrapper.classList.add('is-custom-select');
      wrapper.append(trigger, menu);
      buildOptions();
      sync();
    });

    if (document.documentElement.dataset.moriCustomSelectOutsideClick !== 'true') {
      document.documentElement.dataset.moriCustomSelectOutsideClick = 'true';
      document.addEventListener('pointerdown', (event) => {
        document.querySelectorAll('.mori-variant-picker__select-wrap.is-custom-select.is-open').forEach((wrapper) => {
          if (!wrapper.contains(event.target) && typeof wrapper.moriCustomSelectClose === 'function') {
            wrapper.moriCustomSelectClose();
          }
        });
      });
    }
  }

  function initialiseMoriLegacyColourSwatches() {
    document.querySelectorAll('[data-mori-legacy-colour-swatch]').forEach((swatch) => {
      if (swatch.dataset.swatchInitialised === 'true') return;

      swatch.dataset.swatchInitialised = 'true';
      applyMoriLegacySwatch(
        swatch,
        swatch.dataset.swatchHandle || '',
        swatch.dataset.swatchProductHandle || ''
      );
    });
  }

  function initialiseMoriVariantAnalytics() {
    document.querySelectorAll('[data-mori-variant-analytics]').forEach((label) => {
      if (label.dataset.analyticsInitialised === 'true') return;

      label.dataset.analyticsInitialised = 'true';
      label.addEventListener('click', () => {
        const swatch = label.closest('[data-swatch-type]');
        const moriEvents = window.mori && window.mori.events;

        if (!swatch || !moriEvents || typeof moriEvents.triggerGTMEvents !== 'function') return;

        const isColour = swatch.dataset.swatchType === 'color';
        moriEvents.triggerGTMEvents(
          isColour ? 'colour_swatch' : 'size',
          isColour ? 'colour_click' : 'size_click',
          swatch.dataset.gtmValue || swatch.dataset.swatchValue || ''
        );
      });
    });
  }

  function initialiseMoriVariantCompatibility() {
    document.querySelectorAll('[data-variant-compatibility]').forEach((compatibilityPicker) => {
      if (compatibilityPicker.dataset.initialised === 'true') return;

      const section = compatibilityPicker.closest('.mori-product-section');
      const visiblePicker = section ? section.querySelector('.mori-variant-picker--dropdown') : null;

      if (!visiblePicker) return;

      compatibilityPicker.dataset.initialised = 'true';

      const syncVisibleOptionAvailability = () => {
        const unavailableLabel = visiblePicker.dataset.unavailableLabel || 'Unavailable';

        visiblePicker.querySelectorAll('select[data-option-position]').forEach((select) => {
          const optionPosition = Number(select.dataset.optionPosition);
          const fieldset = compatibilityPicker.querySelector(`[data-option-position="${optionPosition}"]`);

          Array.from(select.options).forEach((option) => {
            if (option.hasAttribute('data-option-placeholder')) return;

            const matchingInput = fieldset
              ? Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
                (input) => input.value === option.value
              )
              : null;
            const unavailable = matchingInput ? matchingInput.classList.contains('disabled') : false;
            const optionLabel = option.dataset.optionLabel || option.value;

            option.classList.toggle('disabled', unavailable);
            option.textContent = unavailable
              ? `${optionLabel} - ${unavailableLabel}`
              : optionLabel;
          });

          syncMoriCustomSelect(select);
        });
      };

      visiblePicker.addEventListener('change', (event) => {
        if (!(event.target instanceof HTMLSelectElement)) return;

        const optionPosition = Number(event.target.dataset.optionPosition);
        const fieldset = compatibilityPicker.querySelector(`[data-option-position="${optionPosition}"]`);
        const matchingInput = fieldset
          ? Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((input) => input.value === event.target.value)
          : null;

        if (matchingInput && !matchingInput.checked) {
          matchingInput.checked = true;
          matchingInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      compatibilityPicker.addEventListener('change', (event) => {
        if (!(event.target instanceof HTMLInputElement)) return;

        const fieldset = event.target.closest('[data-option-position]');
        const optionPosition = fieldset ? Number(fieldset.dataset.optionPosition) : 0;
        const visibleSelect = visiblePicker.querySelector(`[data-option-position="${optionPosition}"]`);

        if (visibleSelect && visibleSelect.value !== event.target.value) {
          visibleSelect.value = event.target.value;
          applyMoriDropdownSwatch(visibleSelect);
          syncMoriCustomSelect(visibleSelect);
        }

        syncVisibleOptionAvailability();
      });

      syncVisibleOptionAvailability();
    });
  }

  function initialiseMoriVariantSelectionValidation() {
    document.querySelectorAll('.mori-product-section').forEach((section) => {
      if (section.dataset.variantSelectionValidationInitialised === 'true') return;

      const picker = section.querySelector('.mori-variant-picker, .mori-variant-picker--legacy');
      const form = section.querySelector('form[data-type="add-to-cart-form"]');
      const requiredGroups = Array.from(section.querySelectorAll('[data-required-variant-option]'));

      if (!picker || !form || !requiredGroups.length) return;

      const variantInput = form.querySelector('input[name="id"]');
      const submitButton = form.querySelector('[name="add"]');
      const submitButtonText = submitButton ? submitButton.querySelector('span') : null;
      const productData = parseMoriJsonScript(section.querySelector('[data-product-variant-data]'));
      const pickerVariants = parseMoriJsonScript(picker.querySelector('script[type="application/json"]'));
      const variants = productData && Array.isArray(productData.variants)
        ? productData.variants
        : pickerVariants;
      const hasAvailableVariant = Array.isArray(variants)
        ? variants.some((variant) => variant.available)
        : true;

      if (submitButtonText && !submitButton.dataset.defaultText) {
        submitButton.dataset.defaultText = submitButtonText.textContent.trim();
      }

      const isGroupMissing = (group) => {
        const select = group.querySelector('select');

        if (select) return !select.value;

        return !group.querySelector('input[type="radio"]:checked');
      };

      const getMissingGroups = () => requiredGroups.filter(isGroupMissing);

      const setGroupError = (group, visible) => {
        const error = group.querySelector('[data-variant-option-error]');
        const control = group.querySelector('.mori-custom-select__trigger, select, input[type="radio"]');

        group.classList.toggle('has-error', visible);
        if (error) error.hidden = !visible;
        if (control) control.setAttribute('aria-invalid', String(visible));
      };

      const syncFormState = () => {
        const hasMissingSelection = getMissingGroups().length > 0;

        if (variantInput) variantInput.disabled = hasMissingSelection;

        if (hasMissingSelection && hasAvailableVariant && submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-disabled');
          if (submitButtonText && submitButton.dataset.defaultText) {
            submitButtonText.textContent = submitButton.dataset.defaultText;
          }
        }
      };

      const focusGroup = (group) => {
        const control = group.querySelector('.mori-custom-select__trigger');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        group.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'center',
        });

        window.setTimeout(() => {
          if (control) {
            control.focus();
          } else {
            group.tabIndex = -1;
            group.focus();
          }
        }, reducedMotion ? 0 : 250);
      };

      const handlePickerChange = (event) => {
        const group = event.target instanceof Element
          ? event.target.closest('[data-required-variant-option]')
          : null;

        if (group && !isGroupMissing(group)) setGroupError(group, false);
        syncFormState();
      };

      const validateSelection = (event, dropdownOnly = false) => {
        const missingGroups = getMissingGroups().filter((group) => (
          !dropdownOnly || group.querySelector('select')
        ));

        if (!missingGroups.length) return true;

        if (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
        missingGroups.forEach((group) => setGroupError(group, true));
        syncFormState();
        focusGroup(missingGroups[0]);

        return false;
      };

      const handleSubmit = (event) => validateSelection(event);

      const handleAddButtonClick = (event) => {
        const addButton = event.target instanceof Element
          ? event.target.closest('[name="add"]')
          : null;

        if (!addButton || !form.contains(addButton)) return;

        validateSelection(event);
      };

      section.moriValidateDropdownSelection = () => validateSelection(null, true);
      picker.addEventListener('change', handlePickerChange);
      section.addEventListener('click', handleAddButtonClick, true);
      form.addEventListener('submit', handleSubmit, true);
      section.dataset.variantSelectionValidationInitialised = 'true';
      section.moriVariantSelectionValidationCleanup = () => {
        picker.removeEventListener('change', handlePickerChange);
        section.removeEventListener('click', handleAddButtonClick, true);
        form.removeEventListener('submit', handleSubmit, true);
        delete section.moriValidateDropdownSelection;
        delete section.dataset.variantSelectionValidationInitialised;
        delete section.moriVariantSelectionValidationCleanup;
      };
      syncFormState();
    });
  }

  function initialiseMoriAdaptiveProductDetails() {
    document.querySelectorAll('[data-adaptive-product-details]').forEach((details) => {
      if (details.dataset.adaptiveStickyInitialised === 'true') return;

      const desktopQuery = window.matchMedia('(min-width: 750px)');
      const stickyHeader = document.querySelector('#complete_header');
      let updateFrame = null;

      const updateStickyState = () => {
        if (updateFrame !== null) return;

        updateFrame = window.requestAnimationFrame(() => {
          updateFrame = null;

          if (!desktopQuery.matches) {
            details.classList.remove('mori-product-details--overflowing');
            details.style.removeProperty('--mori-product-sticky-top');

            return;
          }

          const headerStyle = stickyHeader ? window.getComputedStyle(stickyHeader) : null;
          const headerIsViewportAnchored = headerStyle && ['fixed', 'sticky'].includes(headerStyle.position);
          const headerBottom = headerIsViewportAnchored
            ? Math.max(stickyHeader.getBoundingClientRect().bottom, 0)
            : 0;

          if (headerBottom > 0) {
            details.style.setProperty('--mori-product-sticky-top', `${Math.ceil(headerBottom + 16)}px`);
          } else {
            details.style.removeProperty('--mori-product-sticky-top');
          }

          const topOffset = Number.parseFloat(window.getComputedStyle(details).top) || 0;
          const availableHeight = Math.max(window.innerHeight - topOffset - 24, 0);
          const contentIsTooTall = details.scrollHeight > availableHeight + 1;

          // details.classList.toggle('mori-product-details--overflowing', contentIsTooTall);
        });
      };

      const resizeObserver = 'ResizeObserver' in window
        ? new ResizeObserver(updateStickyState)
        : null;
      const observedHeaderBanners = new WeakSet();
      const observeHeaderBanners = () => {
        if (!resizeObserver) return;

        // Global-e inserts this banner outside the Shopify header after page load.
        document.querySelectorAll('.ge-free-shipping-container').forEach((banner) => {
          if (observedHeaderBanners.has(banner)) return;
          observedHeaderBanners.add(banner);
          resizeObserver.observe(banner);
        });
      };
      // A banner can move the header without changing its observed dimensions.
      const headerPositionObserver = stickyHeader && 'MutationObserver' in window
        ? new MutationObserver(() => {
          observeHeaderBanners();
          updateStickyState();
        })
        : null;

      details.dataset.adaptiveStickyInitialised = 'true';
      if (resizeObserver) {
        resizeObserver.observe(details);
        if (stickyHeader) resizeObserver.observe(stickyHeader);
      }
      if (headerPositionObserver) {
        [stickyHeader, document.body, document.documentElement].forEach((element) => {
          headerPositionObserver.observe(element, {
            attributes: true,
            attributeFilter: ['class', 'style'],
            childList: true,
          });
        });
      }
      observeHeaderBanners();
      window.addEventListener('resize', updateStickyState);
      window.addEventListener('scroll', updateStickyState, { passive: true });
      if (stickyHeader) stickyHeader.addEventListener('transitionend', updateStickyState);
      document.addEventListener('variantChanged', updateStickyState);

      details.moriAdaptiveStickyCleanup = () => {
        if (updateFrame !== null) window.cancelAnimationFrame(updateFrame);
        if (resizeObserver) resizeObserver.disconnect();
        if (headerPositionObserver) headerPositionObserver.disconnect();
        window.removeEventListener('resize', updateStickyState);
        window.removeEventListener('scroll', updateStickyState);
        if (stickyHeader) stickyHeader.removeEventListener('transitionend', updateStickyState);
        document.removeEventListener('variantChanged', updateStickyState);
        delete details.dataset.adaptiveStickyInitialised;
        delete details.moriAdaptiveStickyCleanup;
      };

      updateStickyState();
    });
  }

  function initialiseMoriPersonalisationTriggers() {
    document.querySelectorAll('[data-mori-personalisation-trigger]').forEach((trigger) => {
      if (trigger.dataset.initialised === 'true') return;

      const section = trigger.closest('.mori-product-section');
      const addOns = section ? section.querySelector('#ProductAddOns') : null;

      if (!addOns) return;

      const syncTrigger = () => {
        const source = addOns.querySelector('.personalisation-result-wrapper .personalisation_checkbox');
        let sourceIsAvailable = Boolean(source);
        let ancestor = source ? source.parentElement : null;

        while (ancestor && ancestor !== addOns) {
          if (ancestor.style.display === 'none') {
            sourceIsAvailable = false;
            break;
          }
          ancestor = ancestor.parentElement;
        }

        trigger.hidden = !sourceIsAvailable;
      };

      const handleTriggerClick = () => {
        const source = addOns.querySelector('.personalisation-result-wrapper .personalisation_checkbox');
        if (source) source.click();
      };

      const mutationObserver = new MutationObserver(syncTrigger);

      trigger.dataset.initialised = 'true';
      trigger.addEventListener('click', handleTriggerClick);
      mutationObserver.observe(addOns, {
        attributes: true,
        childList: true,
        subtree: true,
      });

      trigger.moriPersonalisationTriggerCleanup = () => {
        mutationObserver.disconnect();
        trigger.removeEventListener('click', handleTriggerClick);
        delete trigger.dataset.initialised;
        delete trigger.moriPersonalisationTriggerCleanup;
      };

      syncTrigger();
    });
  }

  function initialiseMoriGiftBoxCards() {
    document.querySelectorAll('[data-mori-gift-box-add-ons]').forEach((addOns) => {
      if (addOns.dataset.giftBoxInitialised === 'true') return;

      const sectionId = addOns.dataset.sectionId || 'product';
      const description = addOns.dataset.giftBoxDescription || '';
      const quantityMessage = addOns.dataset.giftBoxQuantityMessage || '';
      let enhanceFrame = null;
      let retryTimeout = null;
      let retryCount = 0;

      const enhanceCards = () => {
        const cards = addOns.querySelectorAll('.giftWrapping');

        cards.forEach((card) => {
          const checkbox = card.querySelector('#add_gift_wrap');
          if (!checkbox) return;
          const isInclusive = checkbox.disabled;

          if (!card.classList.contains('mori-gift-box-card')) {
            card.classList.add('mori-gift-box-card');
          }
          card.classList.toggle('mori-gift-box-card--inclusive', isInclusive);

          const label = card.querySelector('.giftwrap_text_clicked');
          if (label && description && !label.querySelector('.mori-gift-box-card__description')) {
            const descriptionElement = document.createElement('span');
            descriptionElement.className = 'mori-gift-box-card__description';
            descriptionElement.id = `MoriGiftBoxDescription-${sectionId}`;
            descriptionElement.textContent = description;
            label.append(descriptionElement);
            checkbox.setAttribute('aria-describedby', descriptionElement.id);
          }

          const details = card.querySelector('.gift_wrap_details');
          if (
            details
            && !isInclusive
            && quantityMessage
            && !details.querySelector('.mori-gift-box-card__quantity-message')
          ) {
            const quantityElement = document.createElement('p');
            quantityElement.className = 'mori-gift-box-card__quantity-message';
            quantityElement.textContent = quantityMessage;
            details.append(quantityElement);
          }

          const interactiveRow = card.querySelector('.alignment_wrapper');
          if (
            interactiveRow
            && !isInclusive
            && interactiveRow.dataset.giftBoxRowInitialised !== 'true'
          ) {
            const handleRowClick = (event) => {
              if (event.target.closest('input, label, a, button')) return;
              const activeCheckbox = interactiveRow.querySelector('#add_gift_wrap:not(:disabled)');
              if (activeCheckbox) activeCheckbox.click();
            };

            interactiveRow.dataset.giftBoxRowInitialised = 'true';
            interactiveRow.addEventListener('click', handleRowClick);
            interactiveRow.moriGiftBoxRowCleanup = () => {
              interactiveRow.removeEventListener('click', handleRowClick);
              delete interactiveRow.dataset.giftBoxRowInitialised;
              delete interactiveRow.moriGiftBoxRowCleanup;
            };
          }
        });

        return cards.length > 0;
      };

      const scheduleEnhancement = () => {
        if (enhanceFrame) return;

        enhanceFrame = window.requestAnimationFrame(() => {
          enhanceFrame = null;
          enhanceCards();
        });
      };

      const pollForGiftBox = () => {
        retryTimeout = null;

        if (enhanceCards() || retryCount >= 30) return;

        retryCount += 1;
        retryTimeout = window.setTimeout(pollForGiftBox, 100);
      };

      const handleGiftWrapChange = (event) => {
        if (event.target.matches('#add_gift_wrap')) scheduleEnhancement();
      };
      const handleVariantChange = () => {
        retryCount = 0;
        if (retryTimeout) window.clearTimeout(retryTimeout);
        retryTimeout = window.setTimeout(pollForGiftBox, 0);
      };

      addOns.dataset.giftBoxInitialised = 'true';
      addOns.addEventListener('change', handleGiftWrapChange);
      document.addEventListener('variantChanged', handleVariantChange);
      pollForGiftBox();

      addOns.moriGiftBoxCleanup = () => {
        if (enhanceFrame) window.cancelAnimationFrame(enhanceFrame);
        if (retryTimeout) window.clearTimeout(retryTimeout);
        addOns.removeEventListener('change', handleGiftWrapChange);
        document.removeEventListener('variantChanged', handleVariantChange);
        addOns.querySelectorAll('[data-gift-box-row-initialised="true"]').forEach((row) => {
          if (typeof row.moriGiftBoxRowCleanup === 'function') row.moriGiftBoxRowCleanup();
        });
        delete addOns.dataset.giftBoxInitialised;
        delete addOns.moriGiftBoxCleanup;
      };
    });
  }

  function syncMoriProductMediaToOptionControl(event) {
    if (!(event.target instanceof HTMLSelectElement || event.target instanceof HTMLInputElement)) return;

    const section = event.target.closest('.mori-product-section');
    if (!section) return;

    section.querySelectorAll('[data-product-media-grid]').forEach((grid) => {
      const optionGroup = event.target.closest('[data-option-position]');
      const controlPosition = Number(
        event.target.dataset.optionPosition
        || (optionGroup ? optionGroup.dataset.optionPosition : 0)
        || 0
      );
      const controlName = normaliseMoriOptionName(event.target.name);
      const isMediaFilterControl = moriMediaFilterDimensions.some((dimension) => {
        const optionConfig = getMoriMediaOptionConfig(grid, dimension);

        return (
          optionConfig.position
          && controlPosition === optionConfig.position
        ) || (
          optionConfig.name
          && controlName === optionConfig.name
        );
      });

      if (!isMediaFilterControl) return;

      const variantInput = section.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      const variantId = variantInput && variantInput.value
        ? variantInput.value
        : grid.dataset.selectedVariantId;

      updateMoriProductMediaGrid(grid, variantId, true);
    });
  }

  function initialiseMoriProductDetailBlocks() {
    document.querySelectorAll('.mori-product-details').forEach((details) => {
      if (details.dataset.emptyBlocksInitialised === 'true') return;

      let syncFrame = null;
      const ratingTimeouts = new Map();

      const clearRatingTimeout = (block) => {
        const timeout = ratingTimeouts.get(block);

        if (timeout) window.clearTimeout(timeout);
        ratingTimeouts.delete(block);
      };

      const scheduleRatingTimeout = (block) => {
        if (ratingTimeouts.has(block)) return;

        const timeout = window.setTimeout(() => {
          ratingTimeouts.delete(block);
          block.dataset.moriRatingTimedOut = 'true';
          scheduleSync();
        }, 8000);

        ratingTimeouts.set(block, timeout);
      };

      const blockHasMeaningfulContent = (block) => {
        const content = block.cloneNode(true);

        content
          .querySelectorAll('script, style, template, [hidden], input[type="hidden"]')
          .forEach((element) => element.remove());

        if (content.textContent.trim()) return true;

        return Boolean(
          content.querySelector(
            'img[src], picture source[srcset], svg, video, canvas, iframe, button, input:not([type="hidden"]), select, textarea, a[href], [role="button"], [role="link"], i, [class*="star"]'
          )
        );
      };

      const syncBlocks = () => {
        details.querySelectorAll('.mori-product-details__block').forEach((block) => {
          const ratingSnippet = block.querySelector(
            'reviewsio-product-ratings .ruk_rating_snippet');

          if (ratingSnippet) {
            const pendingState = ratingSnippet.getAttribute('data-pending');
            const ratingText = ratingSnippet.textContent.trim();
            const ratingIndicatesNoReviews = /(?:^|[\s(])0\s+reviews?\b|\bno reviews?\b/i.test(ratingText);
            const ratingHasContent = blockHasMeaningfulContent(block) && !ratingIndicatesNoReviews;

            if (pendingState === 'true') block.dataset.moriRatingObservedPending = 'true';

            const ratingHasLoaded = ratingSnippet.hasAttribute('data-retrieved')
              || ratingSnippet.hasAttribute('data-done')
              || pendingState === 'false'
              || (
                block.dataset.moriRatingObservedPending === 'true'
                && !ratingSnippet.hasAttribute('data-pending')
              )
              || block.dataset.moriRatingTimedOut === 'true';

            if (ratingHasContent) {
              clearRatingTimeout(block);
              delete block.dataset.moriRatingTimedOut;
              block.classList.remove('mori-product-details__block--rating-loading');
              block.hidden = false;

              return;
            }

            if (ratingHasLoaded) {
              clearRatingTimeout(block);
            } else {
              scheduleRatingTimeout(block);
            }

            block.classList.toggle('mori-product-details__block--rating-loading', !ratingHasLoaded);
            block.hidden = ratingHasLoaded;

            return;
          }

          block.hidden = !blockHasMeaningfulContent(block);
        });
      };

      const scheduleSync = () => {
        if (syncFrame) return;

        syncFrame = window.requestAnimationFrame(() => {
          syncFrame = null;
          syncBlocks();
        });
      };

      const mutationObserver = new MutationObserver(scheduleSync);

      details.dataset.emptyBlocksInitialised = 'true';
      mutationObserver.observe(details, {
        attributes: true,
        attributeFilter: [
          'aria-hidden',
          'data-done',
          'data-pending',
          'data-retrieved',
          'src',
          'srcset',
        ],
        childList: true,
        characterData: true,
        subtree: true,
      });

      details.moriEmptyBlocksCleanup = () => {
        if (syncFrame) window.cancelAnimationFrame(syncFrame);
        ratingTimeouts.forEach((timeout) => window.clearTimeout(timeout));
        ratingTimeouts.clear();
        mutationObserver.disconnect();
        delete details.dataset.emptyBlocksInitialised;
        delete details.moriEmptyBlocksCleanup;
      };

      syncBlocks();
    });
  }

  function initialiseMoriStickyCarts() {
    document.querySelectorAll('[data-sticky-cart]').forEach((stickyCart) => {
      if (stickyCart.dataset.initialised === 'true') return;

      const section = stickyCart.closest('.mori-product-section');
      const sourceButton = section ? section.querySelector('#AddToCart') : null;
      const stickyButton = stickyCart.querySelector('[data-sticky-cart-button]');
      const stickyPrice = stickyCart.querySelector('[data-sticky-cart-price]');

      if (!sourceButton || !stickyButton) return;

      stickyCart.dataset.initialised = 'true';

      const syncButton = () => {
        const sourceText = sourceButton.querySelector('#AddToCartText');
        const sourcePrice = section.querySelector('[id^="price-"] .product-price');
        stickyButton.textContent = sourceText ? sourceText.textContent.trim() : sourceButton.textContent.trim();
        stickyButton.disabled = sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true';
        if (stickyPrice && sourcePrice) stickyPrice.textContent = sourcePrice.textContent.trim();
      };

      const handleStickyButtonClick = () => {
        syncButton();
        if (!stickyButton.disabled) sourceButton.click();
      };

      const mutationObserver = 'MutationObserver' in window ? new MutationObserver(syncButton) : null;
      const header = document.getElementById('complete_header');
      let intersectionObserver;
      let observedHeaderBottom;
      let visibilityInitialised = false;
      const updateVisibilityObserver = () => {
        const headerBottom = Math.max(
          0,
          Math.round(header ? header.getBoundingClientRect().bottom : 0)
        );
        if (intersectionObserver && headerBottom === observedHeaderBottom)
          return;
        observedHeaderBottom = headerBottom;
        if (intersectionObserver) intersectionObserver.disconnect();
        intersectionObserver = new IntersectionObserver(
          ([entry]) => {
            if (!visibilityInitialised) {
              stickyCart.hidden = entry.intersectionRatio >= 0.95;
              visibilityInitialised = true;

              return;
            }
            if (entry.intersectionRatio >= 0.95) stickyCart.hidden = true;
            else if (entry.intersectionRatio <= 0.5) stickyCart.hidden = false;
          },
          {
            threshold: [0, 0.5, 0.95],
            rootMargin: `-${headerBottom}px 0px 0px 0px`,
          }
        );
        intersectionObserver.observe(sourceButton);
      };
      const headerResizeObserver =
        header && typeof ResizeObserver !== 'undefined'
          ? new ResizeObserver(updateVisibilityObserver)
          : null;

      stickyButton.addEventListener('click', handleStickyButtonClick);
      mutationObserver.observe(sourceButton, {
        attributes: true,
        childList: true,
        subtree: true,
      });
      updateVisibilityObserver();
      if (headerResizeObserver) headerResizeObserver.observe(header);
      window.addEventListener('resize', updateVisibilityObserver);
      document.addEventListener('variantChanged', syncButton);

      stickyCart.moriStickyCartCleanup = () => {
        mutationObserver.disconnect();
        intersectionObserver.disconnect();
        if (headerResizeObserver) headerResizeObserver.disconnect();
        window.removeEventListener('resize', updateVisibilityObserver);
        stickyButton.removeEventListener('click', handleStickyButtonClick);
        document.removeEventListener('variantChanged', syncButton);
        delete stickyCart.dataset.initialised;
        delete stickyCart.moriStickyCartCleanup;
      };

      syncButton();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialiseMoriProductZoom();
      initialiseMoriProductMediaGrids();
      initialiseMoriLinkedColourSelects();
      initialiseMoriDropdownSwatches();
      initialiseMoriCustomSelects();
      initialiseMoriLegacyColourSwatches();
      initialiseMoriVariantAnalytics();
      initialiseMoriVariantCompatibility();
      initialiseMoriDropdownOptionStates();
      initialiseMoriVariantSelectionValidation();
      initialiseMoriAdaptiveProductDetails();
      initialiseMoriPersonalisationTriggers();
      initialiseMoriGiftBoxCards();
      initialiseMoriProductDetailBlocks();
      initialiseMoriStickyCarts();
    });
  } else {
    initialiseMoriProductZoom();
    initialiseMoriProductMediaGrids();
    initialiseMoriLinkedColourSelects();
    initialiseMoriDropdownSwatches();
    initialiseMoriCustomSelects();
    initialiseMoriLegacyColourSwatches();
    initialiseMoriVariantAnalytics();
    initialiseMoriVariantCompatibility();
    initialiseMoriDropdownOptionStates();
    initialiseMoriVariantSelectionValidation();
    initialiseMoriAdaptiveProductDetails();
    initialiseMoriPersonalisationTriggers();
    initialiseMoriGiftBoxCards();
    initialiseMoriProductDetailBlocks();
    initialiseMoriStickyCarts();
  }

  document.addEventListener('variantChanged', syncMoriProductMediaToVariant);
  document.addEventListener('change', syncMoriProductMediaToOptionControl);

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element
      ? event.target.closest('[data-mori-leadgen-trigger]')
      : null;

    if (!button || button.hidden) return;

    const hostname = window.location.hostname.toLowerCase();
    const formId = hostname.includes('eu.babymori.com')
      ? 'SdKWWH'
      : hostname.includes('us.babymori.com')
        ? 'VNYYKK'
        : 'TWsSPZ';

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });

  document.addEventListener('variantChanged', (event) => {
    const variant = event.detail && event.detail.variant;

    if (!variant) return;

    document.querySelectorAll('[data-mori-leadgen-trigger]').forEach((button) => {
      const variantIds = JSON.parse(button.dataset.leadgenVariantIds || '[]');

      if (variantIds.includes(variant.id)) button.hidden = !variant.available;
    });
  });

  if (!window.history.state || !window.history.state.moriLinkedProductUrl) {
    const currentHistoryState = window.history.state && typeof window.history.state === 'object'
      ? window.history.state
      : {};

    window.history.replaceState(
      Object.assign({}, currentHistoryState, {
        moriLinkedProductUrl: `${window.location.pathname}${window.location.search}${window.location.hash}`,
      }),
      '',
      window.location.href
    );
  }

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element
      ? event.target.closest('[data-linked-colour-link]')
      : null;

    if (
      !link ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link.hasAttribute('download') ||
      link.target === '_blank' ||
      link.getAttribute('aria-current') === 'page'
    ) {
      return;
    }

    event.preventDefault();
    renderMoriLinkedProduct(link.href);
  });

  window.addEventListener('popstate', (event) => {
    if (!event.state || !event.state.moriLinkedProductUrl) return;

    renderMoriLinkedProduct(window.location.href, 'popstate');
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.detail || !event.detail.moriLinkedProductRender) {
      moriLinkedProductCache.clear();
    }

    initialiseMoriProductZoom();
    initialiseMoriProductMediaGrids();
    initialiseMoriLinkedColourSelects();
    initialiseMoriDropdownSwatches();
    initialiseMoriCustomSelects();
    initialiseMoriLegacyColourSwatches();
    initialiseMoriVariantAnalytics();
    initialiseMoriVariantCompatibility();
    initialiseMoriDropdownOptionStates();
    initialiseMoriVariantSelectionValidation();
    initialiseMoriAdaptiveProductDetails();
    initialiseMoriPersonalisationTriggers();
    initialiseMoriGiftBoxCards();
    initialiseMoriProductDetailBlocks();
    initialiseMoriStickyCarts();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (moriProductZoom) {
      const zoomableImages = event.target.querySelectorAll('.mori-product-media__image');

      if (zoomableImages.length > 0) moriProductZoom.detach(zoomableImages);
    }

    if (
      (!event.detail || !event.detail.moriLinkedProductRender) &&
      event.target.querySelector('.mori-product-section')
    ) {
      moriLinkedProductRequestSequence += 1;
      if (moriLinkedProductRequestController) moriLinkedProductRequestController.abort();
      moriLinkedProductRequestController = null;
      moriLinkedProductCache.clear();
    }

    event.target.querySelectorAll('[data-adaptive-product-details]').forEach((details) => {
      if (typeof details.moriAdaptiveStickyCleanup === 'function') {
        details.moriAdaptiveStickyCleanup();
      }

      if (typeof details.moriEmptyBlocksCleanup === 'function') {
        details.moriEmptyBlocksCleanup();
      }
    });

    event.target.querySelectorAll('[data-product-media-grid]').forEach((grid) => {
      if (typeof grid.moriMediaPlaybackCleanup === 'function') {
        grid.moriMediaPlaybackCleanup();
      }
    });

    event.target.querySelectorAll('.mori-product-section').forEach((section) => {
      if (typeof section.moriVariantSelectionValidationCleanup === 'function') {
        section.moriVariantSelectionValidationCleanup();
      }
    });

    event.target.querySelectorAll('[data-sticky-cart]').forEach((stickyCart) => {
      if (typeof stickyCart.moriStickyCartCleanup === 'function') {
        stickyCart.moriStickyCartCleanup();
      }
    });

    event.target.querySelectorAll('[data-mori-personalisation-trigger]').forEach((trigger) => {
      if (typeof trigger.moriPersonalisationTriggerCleanup === 'function') {
        trigger.moriPersonalisationTriggerCleanup();
      }
    });

    event.target.querySelectorAll('[data-mori-gift-box-add-ons]').forEach((addOns) => {
      if (typeof addOns.moriGiftBoxCleanup === 'function') {
        addOns.moriGiftBoxCleanup();
      }
    });
  });
})();
